import axios from "src/utils/axios";

const promotionService = {
  getPromotionTypes: () => {
    return axios.get("/api/promotion/types");
  },

  addPromotion: (promotionData) => {
    return axios.post("/api/promotion/addPromotion", promotionData);
  },

  getPromotionData: () => {
    return axios.get("/api/promotion/get/promotion-data");
  },

  addPromotionData: (promotionData) => {
    return axios.post(
      "/api/promotion/add/promotion-data",
      promotionData
    );
  },

  deletePromotion: (promotionData) => {
    return axios.post(
      "/api/promotion/deletePromotion",
      promotionData
    );
  },

  getPromotionsByType: (type) => {
    return axios.get(`/api/promotion/get?type=${type}`);
  },
};

export default promotionService;